import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { SncModalComponent } from 'app/shared/custom/snc-modal/snc-modal.component';
import { PoliticaPrivacidade } from 'app/_models/politica-privacidade';
import { AuthService } from 'app/_services/auth.service';
import { UsuarioService } from 'app/_services/usuario.service';
import { FadeZoomInTop } from "../../animations/fade-zoom-in-top.decorator";

@FadeZoomInTop()
@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styles: [],
  providers: [UsuarioService]
})
export class MainLayoutComponent implements OnInit {

  @ViewChild('modalPrivacyPolicy')
  modalPrivacyPolicy: SncModalComponent;
  @ViewChild('modalBodyTemplate') 
  modalBodyTemplate: TemplateRef<any>;
  politicaPrivacidade: PoliticaPrivacidade = new PoliticaPrivacidade();

  constructor(private authService: AuthService, private usuarioService: UsuarioService, private router: Router) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.changeMenu();
  }

  ngAfterContentInit() {
    this.modalPrivacyPolicySettings();
  }

  private changeMenu() {
    let isMobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
    if(!isMobile) {
      document.body.classList.add('minified');
    } else {
      document.body.classList.add('mobile-view-activated');
    }
  }

  modalPrivacyPolicySettings() {
    const aceitePoliticaPrivacidade = JSON.parse(localStorage.getItem('dn-senac-seguranca')).aceitePoliticaPrivacidade == true;

    if(!aceitePoliticaPrivacidade) {
      this.modalPrivacyPolicy.modal.config = { backdrop: 'static', keyboard: false };
      this.modalPrivacyPolicy.modalBodyTemplate = this.modalBodyTemplate;
      this.modalPrivacyPolicy.show();
    }
  }

  aceitarPolitica() {
    const login = JSON.parse(localStorage.getItem('dn-senac-seguranca')).loginUsuario;
    this.politicaPrivacidade.nomeUsuario = login;
    this.politicaPrivacidade.aceitePoliticaPrivacidade = true;
    this.politicaPrivacidade.aceitePoliticaPrivacidadeSIC = JSON.parse(localStorage.getItem('dn-senac-seguranca')).aceitePoliticaPrivacidadeSIC;
    this.usuarioService.aceitarPoliticaPrivacidade(this.politicaPrivacidade).subscribe(
    (res) => {
      this.modalPrivacyPolicy.hide();
      this.updatePrivacyPolicy();
    });
  }

  recusarPolitica() {
    this.modalPrivacyPolicy.hide();
    this.router.navigate(['/']);
    this.authService.logout();
  }

  updatePrivacyPolicy() {
    const obj = JSON.parse(localStorage.getItem('dn-senac-seguranca'));
    obj.aceitePoliticaPrivacidade = true;
    localStorage.setItem('dn-senac-seguranca', JSON.stringify(obj));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/app-layouts/main-layout.component.ts